import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../common/html/checkbox'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { ScrollComponent } from '../../../common/scrollComponent'
import classes from '../../index.module.scss'
import { PopupTerms } from './PoupTerms'
import { TermsOfUse } from './TermsOfUse'

export const TermsAndCondition = ({
  changeCheckRules,
  selectCheckRules,
  selectTerms,
  appendStyleContainer,
  style,
}) => {
  const dispatch = useDispatch()

  const [isShow, setShow] = useState(false)

  const isCheckRules = useSelector(selectCheckRules)
  const terms = useSelector(selectTerms)

  const onCheck = (check) => {
    dispatch(changeCheckRules(check))
  }

  const onClickExtend = () => {
    setShow(true)
  }

  return (
    <>
      <Element className={classes.containerTerms} style={appendStyleContainer}>
        <Element
          style={{
            backgroundColor: '#FFFFFF',
          }}
        >
          <Element
            className="dFlex alignItemsCenter justifyContentBetween"
            style={{
              borderBottom: '2px solid #DCE0E9',
              padding: '6px 8px',
            }}
          >
            <Element
              className="fw600"
              style={{
                color: '#061530',
              }}
            >
              <Translate value="cartAndOrders.orderInformation.ruleLinkTitle" />
            </Element>
            <div>
              <Icon
                className="icon-extend"
                style={{ fontSize: 20, color: '#9C9C9C' }}
                onClick={onClickExtend}
              />
            </div>
          </Element>
          <div>
            <ScrollComponent autoHeight autoHeightMax={250}>
              <div className={classes.ptb4blt8}>
                {terms && <div dangerouslySetInnerHTML={{ __html: terms }} />}
              </div>
            </ScrollComponent>
          </div>
          <Element
            className={`dFlex alignItemsCenter ${classes.termOrder}`}
            style={style}
          >
            <Checkbox
              checked={isCheckRules}
              onChange={onCheck}
              title={
                <>
                  <Element elementName="p">
                    <Translate value="cartAndOrders.orderInformation.ruleHead" />
                    <TermsOfUse />
                    <Translate value="cartAndOrders.orderInformation.ruleLast" />
                  </Element>
                </>
              }
            />
          </Element>
        </Element>
      </Element>
      {isShow && (
        <PopupTerms
          isShow={isShow}
          handleClose={() => setShow(false)}
          terms={terms}
        />
      )}
    </>
  )
}

TermsAndCondition.propTypes = {
  style: PropTypes.object,
}

TermsAndCondition.defaultProps = {
  style: {
    bottom: 0,
  },
}
